import axios from "axios";
import React, { useState, useEffect } from "react";
import { Config } from "../../../../../../Config";

const VerifyCancelModaL = (props) => {
  const [ItemDetails, setItemDetails] = useState();
  const [Type, setType] = useState("");

  useEffect(() => {
    console.log(props);
    if (props.RequestedItem.position) {
      setItemDetails(props.RequestedItem.position);
      setType("job");
    } else if (props.RequestedItem.project) {
      setItemDetails(props.RequestedItem.project);
      setType("project");
    } else {
      setItemDetails(props.RequestedItem.activity);
      setType("activity");
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenTitle = (Title) => {
    if (window.innerWidth <= 450) {
      if (Title.length < 24) {
        return Title;
      } else {
        return Title.slice(0, 20) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (Title.length < 30) {
        return Title;
      } else {
        return Title.slice(0, 26) + " ...";
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (Title.length < 40) {
        return Title;
      } else {
        return Title.slice(0, 36) + " ...";
      }
    }
  };
  const handleDisplayPopup = () => {
    if (window.innerWidth <= 450) {
      if (ItemDetails.title.length < 24) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1450) {
      if (ItemDetails.title.length < 35) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    } else if (window.innerWidth > 450 && window.innerWidth < 1960) {
      if (ItemDetails.title.length < 45) {
        return null;
      } else {
        return <p className="popup-text">{ItemDetails.title}</p>;
      }
    }
  };
  const cancelApplication = () => {
    let ActionURL;
    let ActionType;
    let Data = {};
    if (Type === "project") {
      ActionURL = Config.ProjectServiceURL;
      ActionType = Type.toLowerCase();
      Data.applicationId = props.RequestedItem.application.id;
    } else if (Type === "activity") {
      ActionURL = Config.ActivityServiceURL;
      ActionType = Type.toLowerCase();
      Data.applicationId = props.RequestedItem.application.id;
    } else {
      ActionURL = Config.PositionServiceURL;
      ActionType = "position";
      Data.applicationId = props.RequestedItem.application.id;
    }
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        ActionURL +
        "/api/" +
        ActionType +
        "/application/cancel",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        props.ClickActivePage();
        props.CloseModal();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  return (
    <div className="cancel-verification-modal-overlay">
      <div className="outline" onClick={() => props.CloseModal()}></div>
      <div className="verification-modal">
        <section className="modal-head">
          {ItemDetails === undefined ? null : (
            <span>
              <h1>{shortenTitle(ItemDetails.title)}</h1>
              {handleDisplayPopup()}
              <p>{ItemDetails.workCity}</p>
            </span>
          )}
          <i onClick={() => props.CloseModal()} className="feather-x"></i>
        </section>
        <section className="modal-body">
          <h1>{translateText("confirm_cancel_application_text")}</h1>
        </section>
        <section className="modal-actions">
          <button onClick={() => props.CloseModal()}>
            {translateText("discard")}
          </button>
          <button onClick={() => cancelApplication()}>
            {translateText("cancel_application")}
          </button>
        </section>
      </div>
    </div>
  );
};

export default VerifyCancelModaL;
